import { RPM_DEVICE_OPTIONS } from "static/constants";

export const convertRpmDeviceObject = (rpmDeviceInfo) => {
  const rpmDeviceArr = [];
  for (const key in rpmDeviceInfo) {
    const selectedDevice = rpmDeviceInfo[key];

    const matchedDeviceOption = RPM_DEVICE_OPTIONS.find(
      (option) => option.key === key
    );
    const deviceName = matchedDeviceOption ? matchedDeviceOption.value : null;

    if (!selectedDevice?.imei || !deviceName) {
      continue;
    }

    const obj = {
      rpmDeviceKey: key,
      rpmDeviceName: deviceName,
      imei: selectedDevice.imei,
      active: selectedDevice.active,
    };
    rpmDeviceArr.push(obj);
  }

  return rpmDeviceArr;
};
